<template>
	<div class="pageloader">
		<div class="loader"></div>
	</div>
</template>

<script>
export default {}
</script>
